<!-- Observer.vue -->
<template>
  <div class="observer"></div>
</template>

<script>
export default {
  props: ["options", "keepConnectedOnIntersection"],
  data: () => ({
    observer: null,
  }),
  mounted() {
    const options = this.options || { rootMargin: "750px" };
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
        if (!this.keepConnectedOnIntersection) {
          this.observer.disconnect();
        }
      }
    }, options);
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>
